/* eslint-disable max-lines */
/* eslint-disable complexity */
import { confirmActionWithSuspiciousItems } from 'Cloud/Application/Suspicious';
import { clone as cloneRamda, path } from 'ramda';
import { downloadItem, downloadItemsZip, openShareDialog, publishSocial } from 'reactApp/appHelpers/appHelpers';
import { IS_BIZ_USER, IS_MOBILE_BROWSER, IS_MOBILE_OR_TABLET_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { renderRenameDialog } from 'reactApp/components/BaseConfirmDialog/BaseInputDialog.helpers';
import { renderEmptyTrashBinDialog } from 'reactApp/components/EmptyTrashBin/EmptyTrashBin.helpers';
import { renderUnpublishWeblinkDialog } from 'reactApp/components/SharingNewBiz/Weblink/SharingNewWeblink.helpers';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import {
    addItemsFromCloudToAlbumRequest,
    createAndPublishAlbumRequest,
    selectAlbumToAddItemsRequest,
} from 'reactApp/modules/albums/albums.actions';
import { isCreatePublicAlbumsEnabled } from 'reactApp/modules/albums/albums.selector';
import { isAlbum } from 'reactApp/modules/albums/albums.types';
import {
    downloadAttachesByIds,
    downloadAttachItem,
    forwardItems,
    getSendViaMailruLink,
    openLink,
    sendAttachesGa,
} from 'reactApp/modules/attaches/attaches.helpers';
import { AttachesSelectors } from 'reactApp/modules/attaches/attaches.selectors';
import { AttachesItem, EAttachTypes } from 'reactApp/modules/attaches/attaches.types';
import { dispatchNewSearchRadar } from 'reactApp/modules/dwh/dwh.module';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getFilesWithFaceIdxs, getFileWithFaceById, getSelectedFaceId } from 'reactApp/modules/faces/faces.selectors';
import { getFeatureAbMailAttachesAfterClose } from 'reactApp/modules/features/features.selectors';
import { getIsViewerFileVerifiedByKaspersky } from 'reactApp/modules/file/utils';
import {
    addToFavorites,
    cloneRequest,
    createNewItem,
    downloadMobileItem as downloadMobileItemAction,
    mountRequest,
    removeFromFavorites,
    removeRequest,
} from 'reactApp/modules/modifying/modifying.actions';
import { getGoToAndScrollUrl } from 'reactApp/modules/modifying/modifying.helpers';
import { PublishItem } from 'reactApp/modules/modifying/modifying.types';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { PublicFile } from 'reactApp/modules/public/public.types';
import { isPublicAlbumTemporaryUrl } from 'reactApp/modules/public/publicAlbum.helper';
import { reDownloadController, ReDownloadEntry } from 'reactApp/modules/requiredAuthorization/reDownloadController';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { scrollToHomeItemAction, toggleAll } from 'reactApp/modules/selections/selections.actions';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { settingsController } from 'reactApp/modules/settings/settings.controller';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { setSort } from 'reactApp/modules/sort/sort.module';
import { ESortOder, ESortTypes } from 'reactApp/modules/sort/sort.types';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import {
    filterIdsByAuthors,
    getCurrentFolder as getCurrentFolderAction,
    getHomeStorageItemIds,
    getItemById,
    getStorageItemById,
    getStorageSelectedItems,
} from 'reactApp/modules/storage/storage.selectors';
import { CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import { trashbinRestoreAllRequest, trashbinRestoreRequest } from 'reactApp/modules/trashbin/trashbin.module';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { showWelcome } from 'reactApp/modules/welcome/welcome.module';
import { sendQuotaCleanerGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import { store as reduxStore } from 'reactApp/store';
import { Sort } from 'reactApp/types/Tree';
import { renderAuthModalDialog } from 'reactApp/ui/Mobile/AuthModal/AuthModal.helpers';
import { renderCopyDialog, renderCreateShareDialog, renderMoveDialog } from 'reactApp/ui/SelectFolderDialog/SelectFolderDialog.toolkit';
import { copy as copyToClipboard } from 'reactApp/utils/copyToClipboard';
import { sendKasperskiSnackAnalitics } from 'reactApp/utils/kasperskiSnackGa';
import opener from 'reactApp/utils/opener';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { getEncodePath } from 'reactApp/utils/urlHelper';

import { publishHelper, unPublishHelper } from './publishHelper';

const getSelectedItems = (state) => {
    const selectedIdxs = SelectionsSelectors.getSelectedIdxs(state);
    const selectedFace = getSelectedFaceId(state);
    if (selectedFace && !selectedIdxs.length) {
        return getFilesWithFaceIdxs(state, selectedFace)
            .map((id) => getFileWithFaceById(state, id))
            .filter((item): item is PublicFile => !!item);
    }
    const selectedStorage = SelectionsSelectors.getStorageSelected(state);
    return selectedIdxs
        .map((id) => getStorageItemById(state, selectedStorage || getCurrentStorage(state), id))
        .filter((item): item is CloudItem => !!item);
};

const getCurrentFolder = (state) => {
    const folder = getCurrentFolderAction(state);

    return folder?.id && folder?.id !== ROOT_FOLDER_ID ? folder : null;
};

export const getSelectedItemsOrCurrentFolder = (id?: string, storage?: EStorageType) => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);
    let selectedItems = getSelectedItems(state);
    const item = id && getStorageItemById(state, storage || currentStorage, id);

    if (item) {
        return [item];
    }

    if (!Array.isArray(selectedItems) || selectedItems.length === 0) {
        const folder = getCurrentFolder(state);
        if (folder) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            selectedItems = [folder];
        }
    }

    return selectedItems;
};

const create = (type: string, from: string, showShareOnlyButton?: boolean, gaPrefix = '', inHomeRoot = false): void => {
    reduxStore.dispatch(
        createNewItem({
            type,
            from,
            showShareOnlyButton,
            gaPrefix,
            inHomeRoot,
        })
    );
};

const view = (type: string) => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);

    sendPaymentGa({
        eventCategory: ECategoryGa.toolbar,
        action: 'change_view',
        source: currentStorage,
    });

    settingsController.setViewMode(type);
};

const sort = (name: string) => {
    const sortName = name.split('-');
    const sort: Sort = { type: sortName[0] as ESortTypes, order: sortName[1] as ESortOder };
    const state = reduxStore.getState();
    const folder = getCurrentFolderAction(state);
    const storage = getCurrentStorage(state);
    const id = folder?.id || ROOT_FOLDER_ID;
    const sortId = IS_BIZ_USER && storage === EStorageType.trashbin ? `${storage}${id}` : id;

    reduxStore.dispatch(setSort({ sort, id: sortId }));
};

const rename = (id?: string): void => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);
    const selectedItems = getSelectedItemsOrCurrentFolder(id);

    if (selectedItems?.length !== 1 || !selectedItems?.[0]) {
        return;
    }

    const onSuccess = () => {
        if (currentStorage === EStorageType.search) {
            const item = selectedItems[0];
            const dwhData = { eventCategory: ECategoryGa.toolbar_search, action: 'rename' };
            const items = [
                {
                    file_name: 'nameWithoutExt' in item && item.nameWithoutExt,
                    type: item.kind,
                    pos: 'pos' in item && item.pos,
                    file_id: item.id,
                },
            ];
            reduxStore.dispatch(
                dispatchNewSearchRadar({
                    dwhData,
                    items,
                })
            );
        }
    };

    renderRenameDialog(selectedItems[0], onSuccess);
};

const toggleFavorites = (): void => {
    const state = reduxStore.getState();
    const selectedItems = getSelectedItems(state);

    if (!selectedItems?.length) {
        return;
    }

    const isAllInFav = selectedItems.every((item) => path(['isInFavorites'], item));

    if (isAllInFav) {
        reduxStore.dispatch(removeFromFavorites({ items: selectedItems }));
        return;
    }

    reduxStore.dispatch(addToFavorites({ items: selectedItems, from: 'toolbar' }));
};

const copy = (id?: string, sendAnalytics?: (data?: any) => void): void => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);
    const items = getSelectedItemsOrCurrentFolder(id);

    if (!items?.length) {
        return;
    }

    const onSuccess = () => {
        sendAnalytics?.({
            action: 'copy',
            source: currentStorage,
            count_files: items.length,
            items,
        });
    };

    renderCopyDialog({ items, onSuccess });
};

const download = ({
    useDownloadUrl = false,
    id,
    storage,
    fromReDownload = false,
}: { useDownloadUrl?: boolean; id?: string; storage?: EStorageType; fromReDownload?: boolean } = {}): void => {
    const state = reduxStore.getState();
    const currentFolder = getCurrentFolderAction(state);
    let selected = getSelectedItems(state);

    /* tempexp_15344-start */
    if (fromReDownload) {
        const reDownloadParams = reDownloadController.getParams(ReDownloadEntry.Toolbar);

        if (reDownloadParams) {
            selected = reDownloadParams.selected;
        }
    }
    /* tempexp_15344-end */

    const currentStorage = getCurrentStorage(state);
    const item = id && getStorageItemById(state, storage || currentStorage, id);
    const isNewbie = UserSelectors.isNewbie(state);

    if (item && !selected.length) {
        selected = [item];
    }

    /* tempexp_15344-next-line */
    reDownloadController.setFutureParams(ReDownloadEntry.Toolbar, {
        useDownloadUrl,
        id,
        storage,
        selected,
    });

    const { isAttaches, isFavorites, isSearch, isHome, isPublic, isAlbums } = getStorage(currentStorage);

    if (!currentFolder && !selected?.length) {
        return;
    }

    // tempexp-15346-start
    if (isNewbie) {
        reduxStore.dispatch(showWelcome());
        return;
    }
    // tempexp-15346-end

    sendPaymentGa({
        eventCategory: ECategoryGa.toolbar,
        action: 'download_content',
        source: currentStorage,
        count_files: selected.length || 1,
    });

    if (isAttaches && selected?.length) {
        sendAttachesGa('download-from-toolbar', selected.length.toString());

        selected.forEach((item) => sendAttachesGa('download', 'ext' in item ? item.ext : ''));

        if (selected.length === 1) {
            const attachType: string | undefined = path(['attachType'], selected[0]);
            const isCloudAttachType = attachType === EAttachTypes.cloud || attachType === EAttachTypes.cloudStock;

            if (isCloudAttachType) {
                downloadItem({ itemOrId: selected[0], useDownloadUrl, storage: storage || currentStorage });
            } else {
                downloadAttachItem(selected[0] as AttachesItem).then(() => {
                    if (getIsViewerFileVerifiedByKaspersky(state)) {
                        /**
                         * Показываем снэк только для пабликов и для аттачей(CLOUDWEB-14706)
                         * и самым последним этапом скачивания, что бы не мешался другим модалкам на тача
                         * (Пришлось его продублировать тут, т.к. аттачи на таче скачиваются иначе, чем всё остальное)
                         */
                        snackbarController.showSnackbar({
                            id: 'protected-download',
                            closable: true,
                            title: 'Скачивание началось',
                            text: IS_MOBILE_BROWSER
                                ? 'Файл проверен Касперским и безопасен для вашего смартфона'
                                : 'Файл проверен антивирусом Касперского и безопасен для вашего компьютера',
                            type: SnackbarTypes.protect,
                            onShow: () => {
                                sendKasperskiSnackAnalitics({ action: 'view' });
                            },
                            onClose: () => {
                                sendKasperskiSnackAnalitics({ action: 'close' });
                            },
                        });
                    }
                });
            }
        } else {
            sendAttachesGa('download-multiple');
            confirmActionWithSuspiciousItems(cloneRamda(selected), 'download').then(function () {
                downloadAttachesByIds(selected.map((item) => item.id));
            });
        }

        return;
    }

    if ((isFavorites || isSearch) && !selected.length && currentFolder && 'list' in currentFolder) {
        downloadItemsZip({ items: Object.values(currentFolder.list), name: isFavorites ? 'favorites' : 'archive' });
        return;
    }

    if (selected.length === 1) {
        if (selected[0].isFolder) {
            downloadItemsZip({ items: selected, name: selected[0].name });
        } else {
            downloadItem({ itemOrId: selected[0], useDownloadUrl, storage: currentStorage });
        }

        return;
    }

    const name = (isHome || isPublic || isAlbums) && currentFolder && 'name' in currentFolder ? currentFolder?.name : 'archive';
    downloadItemsZip({ items: selected.length ? selected : [currentFolder], name });
};

const viewHistory = (contextMenu?: boolean): void => {
    const state = reduxStore.getState();
    const selectedItem = getSelectedItems(state)[0];
    const currentStorage = getCurrentStorage(state);
    if (currentStorage === EStorageType.search) {
        const dwhData = {
            eventCategory: contextMenu ? ECategoryGa.context_search : ECategoryGa.toolbar_search,
            action: 'open-history',
        };

        reduxStore.dispatch(
            dispatchNewSearchRadar({
                dwhData,
                items: [
                    {
                        file_name: 'nameWithoutExt' in selectedItem && selectedItem.nameWithoutExt,
                        file_id: selectedItem.id,
                        pos: 'pos' in selectedItem && selectedItem.pos,
                        type: selectedItem.kind,
                    },
                ],
            })
        );
    }
    openPopupHelper({ popupName: popupNames.FILE_HISTORY, data: { itemId: selectedItem?.id } });
};

const move = (id?: string, sendAnalytics?: (data?: any) => void): void => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);
    const items = getSelectedItemsOrCurrentFolder(id);

    if (!items.length) {
        return;
    }

    const onSuccess = () => {
        sendAnalytics?.({
            action: 'move_to_folder',
            source: currentStorage,
            count_files: items.length,
            items,
        });
    };

    renderMoveDialog({ items, onSuccess });
};

const remove = (id?: string, sendAnalytics?: (data?: any) => void): void => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);
    const items = getSelectedItemsOrCurrentFolder();
    const item = id && getItemById(state, id);

    const onSuccess = () => {
        sendAnalytics?.({
            action: 'delete',
            source: currentStorage,
            count_files: items.length,
            items,
        });
    };

    reduxStore.dispatch(removeRequest({ items: item ? [item] : items, withRemoveDialog: true, onSuccess }));
};

const selectAll = (ownStorage?: EStorageType): void => {
    const state = reduxStore.getState();
    const storage = ownStorage || getCurrentStorage(state);

    const ids = getHomeStorageItemIds(state, storage);
    const allIdxs = filterIdsByAuthors(state, ids, storage);
    const allSelectedIdx = getStorageSelectedItems(state, storage);
    const isDeselectAll = allIdxs?.length && allIdxs?.length === allSelectedIdx?.length;

    reduxStore.dispatch(toggleAll({ allIdxs, storage }));

    if (storage === EStorageType.quotaCleaner) {
        const prefix = isDeselectAll ? 'all-files-select-cancel' : 'all-files-select';
        sendQuotaCleanerGa({ action: prefix, dwh: { count_select_files: allIdxs?.length } });
    }

    if (!isDeselectAll) {
        sendPaymentGa({
            eventCategory: ECategoryGa.toolbar,
            action: 'select_all',
            source: storage,
        });
    }
};

const share = (id?: string): void => {
    const state = reduxStore.getState();
    const selectedItems = getSelectedItemsOrCurrentFolder();
    const item = (id && getItemById(state, id)) || (selectedItems.length === 1 && selectedItems[0]);
    const storage = getCurrentStorage(state);
    const { isReactPage } = getStorage(storage);

    // tempexp-15346-start
    const ifFromAttaches = AttachesSelectors.getIsFromAttaches(state);
    const isNewbie = UserSelectors.isNewbie(state);
    const abMailAttachesAfterClose = getFeatureAbMailAttachesAfterClose(state);
    if (isNewbie && ifFromAttaches && abMailAttachesAfterClose === 'b') {
        reduxStore.dispatch(showWelcome());
        return;
    }
    // tempexp-15346-end

    if ((item && item.id === '/') || !selectedItems.length) {
        renderCreateShareDialog({
            onSuccess: (item) => reduxStore.dispatch(openShareDialog({ item })),
            isReactPage,
        });
        return;
    }

    reduxStore.dispatch(openShareDialog({ item }));
};

const publish = (publishFrom = '', id?: string, storage?: EStorageType): void => {
    const state = reduxStore.getState();
    const currentStorage = storage || getCurrentStorage(state);
    const selectedItems = getSelectedItemsOrCurrentFolder(id, storage);
    const item = selectedItems.length === 1 ? selectedItems[0] : undefined;
    const isPublicAlbumEnabled = isCreatePublicAlbumsEnabled(state, selectedItems);

    if (currentStorage === EStorageType.search && item) {
        const dwhData = { eventCategory: ECategoryGa.toolbar_search, action: 'created-public' };
        const items = [
            {
                file_name: 'nameWithoutExt' in item && item.nameWithoutExt,
                type: item.kind,
                pos: 'pos' in item && item.pos,
                file_id: item.id,
                public_id: ('weblink' in item && item.weblink) || '',
            },
        ];
        reduxStore.dispatch(
            dispatchNewSearchRadar({
                dwhData,
                items,
            })
        );
    }

    if (!selectedItems.length || item?.id === '/') {
        return;
    }

    if (isPublicAlbumEnabled && !selectedItems.every(isAlbum)) {
        reduxStore.dispatch(createAndPublishAlbumRequest({ items: selectedItems }));
        return;
    }

    publishHelper({ item, publishFrom, itemStorage: storage });
};

const unPublish = (): void => {
    const state = reduxStore.getState();
    const selectedItems = getSelectedItems(state).filter((item) => path(['weblink'], item)) as PublishItem[];

    if (!selectedItems.length) {
        return;
    }

    const onActionClick = () => unPublishHelper({ items: selectedItems });

    if (IS_BIZ_USER) {
        renderUnpublishWeblinkDialog({ onActionClick });
        return;
    }

    onActionClick();
};

const restore = (id?: string): void => {
    const state = reduxStore.getState();
    const ids = id ? [id] : SelectionsSelectors.getSelectedIdxs(state);
    reduxStore.dispatch(trashbinRestoreRequest({ ids, from: 'toolbar' }));
};

const restoreAll = (): void => {
    reduxStore.dispatch(trashbinRestoreAllRequest());
};

const clear = (): void => {
    renderEmptyTrashBinDialog();
};

const forward = ({ items }: { items: CloudItem[] | null } = { items: null }): void => {
    const state = reduxStore.getState();
    const storage = SelectionsSelectors.getStorageSelected(state) || getCurrentStorage(state);

    if (storage === EStorageType.attaches) {
        const ids = SelectionsSelectors.getSelectedIdxs(state);
        const items = ids.map((id) => AttachesSelectors.getAttachById(state, id));
        reduxStore.dispatch(
            dispatchNewSearchRadar({
                dwhData: { eventCategory: ECategoryGa.viewer_search, action: 'send-mail' },
                items: items.map((item) => ({
                    file_name: item.nameWithoutExt,
                    type: item.kind,
                    pos: item.pos,
                    file_id: item.id,
                    extension: item.isFolder ? 'None' : item.ext,
                })),
            })
        );

        items.forEach((item) => sendAttachesGa('forward', item.ext));

        if (items?.length > 1) {
            sendAttachesGa('forward-multiple');
        }

        forwardItems(ids);
    } else {
        if (!items) {
            items = getSelectedItems(state);
        }

        const item = items.length ? items[0] : getCurrentFolderAction(state);

        if (storage === EStorageType.search && item) {
            reduxStore.dispatch(
                dispatchNewSearchRadar({
                    dwhData: { eventCategory: ECategoryGa.viewer_search, action: 'send-mail' },
                    items: [
                        {
                            file_name: 'nameWithoutExt' in item && item.nameWithoutExt,
                            type: 'kind' in item && item.kind,
                            pos: 'pos' in item && item.pos,
                            file_id: item.id,
                            extension: 'isFolder' in item && item.isFolder ? 'None' : 'ext' in item && item.ext,
                        },
                    ],
                })
            );
        }

        if ((storage === EStorageType.public || storage === EStorageType.stock) && (!items || items.length <= 1)) {
            publishSocial('email', item);
            return;
        }

        if (Array.isArray(items)) {
            const url = getSendViaMailruLink(items, storage);
            openLink(url);
        }
    }
};

const mount = (): void => {
    const state = reduxStore.getState();
    const selectedItems = getSelectedItems(state);
    const item = selectedItems.length === 1 && selectedItems[0];

    if (!item) {
        return;
    }

    // @ts-ignore
    reduxStore.dispatch(mountRequest({ item }));
};

interface IToolbarClone {
    // source для dwh
    source: string;
    id?: string;
    destination?: string;
    autoClone?: boolean;
    storage?: EStorageType;
    // Не показывать снекбар об успехе клонирования
    noOkSnackbar?: boolean;
    fromReDownload?: boolean;
}

const clone = ({ id, source, destination, autoClone, storage, noOkSnackbar, fromReDownload }: IToolbarClone): void => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);
    let items = getSelectedItemsOrCurrentFolder();
    let item = id && getStorageItemById(state, storage || currentStorage, id);
    const isAnonymous = UserSelectors.isAnonymous(state);
    const isPhone = EnvironmentSelectors.isPhone();

    /* tempexp_15344-start */
    if (fromReDownload) {
        const reDownloadParams = reDownloadController.getParams(ReDownloadEntry.Toolbar);

        if (reDownloadParams) {
            items = reDownloadParams.selected;

            if (reDownloadParams.selected?.length > 0) {
                item = undefined;
            }
        }
    }
    /* tempexp_15344-end */

    if (isAnonymous && isPhone) {
        renderAuthModalDialog();
        return;
    }

    reduxStore.dispatch(cloneRequest({ items: item ? [item] : items, source, destination, autoClone, noOkSnackbar }));
};

const shareLink = ({ id, url, useNativeShare = true }: { id?: string; url?: string; useNativeShare?: boolean }): void => {
    const state = reduxStore.getState();
    const storage = getCurrentStorage(state);

    const isNativeShareSupported = IS_MOBILE_OR_TABLET_BROWSER && 'share' in navigator && typeof navigator.share === 'function';

    const currentStorage = isPublicAlbumTemporaryUrl() ? 'album' : storage;

    const href = id ? `${window.location.origin}/${currentStorage}/${id}` : window.location.href;
    const copyUrl = url || href;

    if (isNativeShareSupported && useNativeShare) {
        navigator.share({ url: copyUrl }).catch(() => {});
        return;
    }

    copyToClipboard(copyUrl)
        .then(({ hasBeenCopied }) => {
            if (hasBeenCopied) {
                reduxStore.dispatch(
                    showSnackbarAction({
                        id: 'copy-link',
                        closable: true,
                        text: 'Ссылка успешно скопирована',
                        type: SnackbarTypes.success,
                    })
                );
            }
        })
        .catch(() => {
            reduxStore.dispatch(
                showSnackbarAction({
                    id: 'copy-link',
                    closable: true,
                    text: 'Не удалось скопировать ссылку',
                    type: SnackbarTypes.failure,
                })
            );
        });
};

const downloadMobileItem = () => {
    reduxStore.dispatch(downloadMobileItemAction());
};

const showInParentFolder = ({ folderId, itemId }: { folderId: string; itemId?: string }) => {
    const state = reduxStore.getState();
    const storage = getCurrentStorage(state);

    const { isReactPage } = getStorage(storage);

    if (!isReactPage) {
        const selectedFolderId = folderId === ROOT_FOLDER_ID ? '' : getEncodePath(folderId);
        const url = getGoToAndScrollUrl(selectedFolderId, itemId);

        opener(url, true);
        return;
    }

    reduxStore.dispatch(scrollToHomeItemAction({ parentFolderId: folderId, itemId }));
};

const addToAlbum = () => {
    const state = reduxStore.getState();
    const storage = getCurrentStorage(state);
    const items = getSelectedItems(state) || [];

    const selectedItems = getSelectedItemsOrCurrentFolder();
    const isAlbumItem = selectedItems.length === 1 && isAlbum(selectedItems?.[0]);

    if (storage === EStorageType.albums && isAlbumItem) {
        reduxStore.dispatch(addItemsFromCloudToAlbumRequest({ id: selectedItems?.[0]?.id }));
        return;
    }

    if (!items?.length) {
        return;
    }

    reduxStore.dispatch(selectAlbumToAddItemsRequest({ items }));
};

const createAndPublishAlbum = () => {
    const state = reduxStore.getState();
    const items = getSelectedItems(state);

    reduxStore.dispatch(createAndPublishAlbumRequest({ items }));
};

export const toolbarActions = {
    create,
    view,
    sort,
    rename,
    toggleFavorites,
    copy,
    download,
    viewHistory,
    move,
    remove,
    selectAll,
    share,
    publish,
    unPublish,
    restore,
    restoreAll,
    clear,
    forward,
    mount,
    clone,
    shareLink,
    downloadMobileItem,
    showInParentFolder,
    addToAlbum,
    createAndPublishAlbum,
};
